import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeParkingsAlertsPeriodFilter } from '../../../ac/onChangeMapFilters';
import { ParkingsAlertsPointsPeriodFilterValues } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const ParkingsAlertsPointsFilterComponent = ({
    onChangeParkingsAlertsPeriodFilter,
    parkingsAlertsPointsPeriodStatuses,
}) => (
    <div>
        <div className={styles.legHead}>{t`Период алертов`}:</div>
        <StandardRadioGroup
            value={String(parkingsAlertsPointsPeriodStatuses)}
            onChange={onChangeParkingsAlertsPeriodFilter}
        >
            {
                ParkingsAlertsPointsPeriodFilterValues.map(value => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={parkingsAlertsPointsPeriodStatuses === value}
                                onChange={onChangeParkingsAlertsPeriodFilter}
                                value={value}
                                className={classnames(
                                    styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: parkingsAlertsPointsPeriodStatuses === value,
                                    }
                                )}
                                size='small'
                            />
                        }
                        label={value === 1 ? t`${value} день` : value === 3 ? t`${value} дня` : t`${value} дней`}
                        labelPlacement='end'
                    />
                ))
            }
        </StandardRadioGroup>
    </div>
);
const mapStateToProps = ({ mapFilters: { parkingsAlertsPointsPeriodStatuses } }) => ({ parkingsAlertsPointsPeriodStatuses });
const ConnectedComponent = connect(mapStateToProps, { onChangeParkingsAlertsPeriodFilter })(ParkingsAlertsPointsFilterComponent);

export const ParkingsAlertsPointsPeriodFilter = withDisplayedLayersCheck(ConnectedComponent, t`Алерты завершения парковки`);
